import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  currentTimeInt: number;
  constructor() {
    setInterval(() => {
      this.currentTimeInt = new Date().getTime();
    }, 1000);
  }

  getTime(dateInt) {
    const date = new Date(dateInt);
    return (
      date.getMonth() +
      '/' +
      date.getDate() +
      ' ' +
      date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      })
    );
  }

  getTimeLeftInt(timeInt, currentTimeInt) {
    if (!timeInt) {
      return null;
    }
    const date = new Date(timeInt);
    date.setDate(date.getDate() + 1);
    return date.getTime() - currentTimeInt;
  }

  getTimeLeftString(timeInt, currentTimeInt) {
    const t = this.getTimeLeftInt(timeInt, currentTimeInt);
    if (!t) {
      return '';
    }
    const seconds = this.formatTimeNumber(Math.floor((t / 1000) % 60));
    const minutes = this.formatTimeNumber(Math.floor((t / 1000 / 60) % 60));
    const hours = this.formatTimeNumber(
      Math.floor((t / (1000 * 60 * 60)) % 24)
    );
    if (t < 0) {
      return 'Bid Won';
    }
    return hours + ':' + minutes + ':' + seconds;
  }

  private formatTimeNumber(input) {
    if (input.toString().length > 1) {
      return input;
    } else {
      return '0' + input;
    }
  }
}
